import { createContext } from "react";

/** The nearest full admin shell's React-owned destination. Null shadows outer shells. */
export const TopbarBreadcrumbSlotContext = createContext<HTMLElement | null>(null);
/** Mounted portals report their own stable identity; disabled shells shadow this too. */
export const TopbarBreadcrumbClaimContext = createContext<((id: string, mounted: boolean) => void) | null>(null);
export const TOPBAR_BREADCRUMB_BREAKPOINT = 768;
